export default (function($) {
  'use strict';

  $(document).ready(function() {
    $('#faqs').bind('change', function() {
      const select = $(this)[0];
      const selectedIndex = select.selectedIndex;
      const postURL = select[selectedIndex].value;

      // Reset the selectedIndex so if the user clicks back the form
      // will default back to having the disabled element selected.
      select.selectedIndex = 0;

      window.location.href = postURL;
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/faqs-form.js